import { useEffect } from 'react'

import { useContainerWidth } from '../../../../../hooks'
import { LAUNCHER_ROW_WIDTH_PROPERTY } from '../../LayoutOverlay.constants'

export function useLauncherRowWidth({ enabled, ref }) {
  const width = useContainerWidth(ref)

  useEffect(() => {
    if (enabled && width !== null) {
      const root = document.documentElement

      root.style.setProperty(LAUNCHER_ROW_WIDTH_PROPERTY, `${width}px`)

      return () => {
        root.style.removeProperty(LAUNCHER_ROW_WIDTH_PROPERTY)
      }
    }
  }, [enabled, width])
}
